import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `${ctx.brand} startsida Norden & Baltikum`,
    languageButtonLabel: `Språk`,
    languageModalTitle: `Välj språk`,
    languageModalCloseLabel: `Stäng språkmeny`,
  },
  languageOptions: {
    'en-US': {
      label: `Engelska`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `Engelska (Kenya)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `Engelska (Nigeria)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `Engelska (Singapore)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `Portugisiska`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Português (Brasil)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `Tyska`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Deutsch (Österreich)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Deutsch (Schweiz)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `Spanska`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `Franska`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `Italienska`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `Nederländska`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Polski`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `Nordiskt & Baltiskt`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Dansk`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Suomi`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norsk`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Íslenska`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `Japanska`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `Koreanska`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `Mandarin`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `Kantonesiska`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Tiếng Việt`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `Thailändska`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Bahasa Indonesia`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Kiswahili`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `Hindi`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `বাংলা`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `मराठी`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `తెలుగు`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `Farsi`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `اردو`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `پنجابی`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Naijá Pidgin`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `Ryska`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `Arabiska`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `العربية (الإمارات)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `العربية (قطر)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `Marockansk arabiska`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Türkçe`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `Välj språk`,
    closeLabel: `Stäng språkmeny`,
  },
  languageHint: (ctx) => `Hoppa mellan ${ctx.localesCount}+ språkversioner.`,
  readPagePrompt: ({languageLabel}) => `Läs den här sidan på ${languageLabel}.`,
};
